import { render, staticRenderFns } from "./privacy_request.vue?vue&type=template&id=4b8954e1&scoped=true"
import script from "./privacy_request.vue?vue&type=script&lang=js"
export * from "./privacy_request.vue?vue&type=script&lang=js"
import style0 from "./privacy_request.vue?vue&type=style&index=0&id=4b8954e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8954e1",
  null
  
)

export default component.exports